import { AuthStorage } from "utils/auth-storage";
import React, { useEffect, useState } from "react";
import { Modal, Button, Select, Card, Table, Tag, Dropdown } from "antd";
import { WarehouseServices } from "apis/Services/WarehouseService";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import LoadingComponent from "components/loading-component";
import { MoreOutlined } from "@ant-design/icons";
import PostToProcoreModal from "pages/warehouse-inventory/post-to-procore-modal";
import { CompanyAdminServices } from "apis/Services/CompanyAdminService";
import LineItemsModal from "./line-items-modal";

const GetPurchasedOrders = ({
  record,
  isGetPurchasedOrdersVisible,
  setIsGetPurchasedOrdersVisible,
  setShouldReload = () => {},
  accessLevel,
}) => {
  const { company_id } = useParams();
  const [projects, setProjects] = useState();
  const [purchasedItemsList, setPurchasedItemsList] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [currentStep, setCurrentStep] = useState(1); // 1 for project list, 2 for next div
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isPostToProcoreVisible, setIsPostToProcoreVisible] = useState(false);
  const [isPostLineItemVisible, setIsPostLineItemVisible] = useState(false);

  useEffect(() => {
    if (!projects) {
      let code = AuthStorage.getItem("token");
      let email = AuthStorage.getItem("email");
      let ReqObj = {
        company_id: company_id,
        code,
        loginEmail: email,
      };
      CompanyAdminServices.readRegisteredProjects(ReqObj)
        .then((res) => {
          // console.log(res.content, "RESPONSEEE");
          setProjects(res.content);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, []);

  const getProjectPurchaseOrders = () => {
    if (!selectedProject) {
      return;
    }

    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");
    let ReqObj = {
      company: company_id,
      code,
      loginEmail: email,
      projectID: selectedProject?.projectID,
    };
    WarehouseServices.getProjectPurchaseOrdersFromProcore(ReqObj)
      .then((res) => {
        // console.log(res, "RESPONSEEE");
        setPurchasedItemsList(res);
        //   setProjects(res);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const onSubmit = () => {
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");
    let ReqObj = {
      company: company_id,
      code,
      loginEmail: email,
      projectID: selectedProject?.projectID,
      selectedItems: selectedItems,
    };

    WarehouseServices.savePurchaseOrder(ReqObj)
      .then((res) => {
        toast.success("Send to Koncurent successfully!");
        setShouldReload(true);
        onCancel();
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong, please try again.");
      });
  };

  const onCancel = () => {
    setIsGetPurchasedOrdersVisible(false);
    setSelectedProject(null);
    setPurchasedItemsList(null);
    setSelectedRowKeys([]);
    setSelectedItems([]);
    setIsLoading(true);

    setTimeout(() => {
      setCurrentStep(1);
    }, 300);
  };

  const onBack = () => {
    setCurrentStep(1);
    setPurchasedItemsList(null);
    setSelectedProject(null);
    setSelectedRowKeys([]);
    setSelectedItems([]);
    setIsLoading(true);
  };

  const handleContinue = () => {
    if (selectedProject) {
      getProjectPurchaseOrders();
      setCurrentStep(2);
    } else {
      toast.error("Please select a project first.");
    }
  };

  const handleSendToKoncurent = () => {
    // Your send to Koncurent logic here
    // console.log("Selected items to send:", selectedItems);
    onSubmit();
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "title",
      key: "title",
      render: (text, record) => (
        <div>
          {text}
          {record.existsInKoncurent && (
            <Tag
              bordered
              className=" ms-2 fw-bold rounded rounded-5"
              color="blue"
            >
              Sent
            </Tag>
          )}
        </div>
      ),
    },
    {
      title: "Number",
      dataIndex: "number",
      key: "number",
    },
    {
      title: "Accounting Method",
      dataIndex: "accounting_method",
      key: "accounting_method",
      render: (value) => (value === "amount" ? "Amount Based" : "Unit/Qty"),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <Dropdown
          menu={{
            items: [
              {
                key: "update",
                label: "Update Purchase Order",
                onClick: () => handleUpdatePurchaseOrder(record),
              },
              {
                key: "get-line-item",
                label: "Get Line Items",
                onClick: () => handleGetLineItem(record),
              },
            ],
          }}
          trigger={["click"]}
        >
          <Button type="text" shape="circle">
            <MoreOutlined />
          </Button>
        </Dropdown>
      ),
    },
  ];
  const handleUpdatePurchaseOrder = (record) => {
    setSelectedItem(record);
    setIsPostToProcoreVisible(true);
  };
  const handleGetLineItem = (record) => {
    setSelectedItem(record);
    setIsPostLineItemVisible(true);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      // console.log(
      //   `selectedRowKeys: ${selectedRowKeys}`,
      //   "selectedRows: ",
      //   selectedRows
      // );

      setSelectedRowKeys(selectedRowKeys);

      // Create the array of objects with contractNumber and purchaseOrderID
      const selectedItemsArray = selectedRows.map((item) => ({
        procorePOID: item.purchaseOrderID?.toString(),
        contractNumber: item.number,
      }));

      setSelectedItems(selectedItemsArray);
      // console.log("Selected items array:", selectedItemsArray);
    },
    getCheckboxProps: (record) => ({
      disabled: record.existsInKoncurent === true, // Disable if exists in Koncurent
      name: record.name,
    }),
  };

  const handleRowClick = (record) => {
    if (record.existsInKoncurent === true) {
      // console.log("Item exists in Koncurent, selection blocked");
      return;
    }

    const key = record.purchaseOrderID;
    const isSelected = selectedRowKeys.includes(key);

    let newSelectedRowKeys;
    let newSelectedRows;

    if (isSelected) {
      // Remove from selection
      newSelectedRowKeys = selectedRowKeys.filter((k) => k !== key);
      newSelectedRows = selectedItems.filter(
        (item) => item.purchaseOrderID !== record.purchaseOrderID
      );
    } else {
      // Add to selection
      newSelectedRowKeys = [...selectedRowKeys, key];
      const newItem = {
        procorePOID: record.purchaseOrderID?.toString(),
        contractNumber: record.number,
      };
      newSelectedRows = [...selectedItems, newItem];
    }

    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedItems(newSelectedRows);
    // console.log("Selected items array:", newSelectedRows);
  };

  const renderNextStep = () => (
    <div>
      <h4 className=" mb-3">{selectedProject?.["Project Name"]}</h4>
      {/* Add your next step content here */}
      <Table
        dataSource={purchasedItemsList}
        columns={columns}
        loading={{
          spinning: isLoading,
          indicator: <LoadingComponent />,
        }}
        bordered
        rowKey="purchaseOrderID"
        rowSelection={{ type: "checkbox", ...rowSelection }}
        onRow={(record) => ({
          onClick: () => handleRowClick(record),
          style: {
            cursor:
              record.existsInKoncurent === true ? "not-allowed" : "pointer",
            opacity: record.existsInKoncurent === true ? 0.8 : 1,
          },
        })}
      />

      <PostToProcoreModal
        record={selectedItem}
        isPostToProcoreVisible={isPostToProcoreVisible}
        setIsPostToProcoreVisible={setIsPostToProcoreVisible}
        editMode={true}
        projectID={selectedProject?.projectID}
        setShouldReload={getProjectPurchaseOrders}
      />

      <LineItemsModal
        record={selectedItem}
        isPostLineItemVisible={isPostLineItemVisible}
        setIsPostLineItemVisible={setIsPostLineItemVisible}
        projectID={selectedProject?.projectID}
        setShouldReload={getProjectPurchaseOrders}
        accessLevel={accessLevel}
      />
    </div>
  );

  const renderProjectList = () => (
    <div className=" d-flex flex-column justify-content-center align-items-center p-3">
      <h4>Select a Procore Project</h4>
      <Select
        style={{ width: "80%" }}
        placeholder="Select a project"
        value={selectedProject?.projectID}
        onChange={(value) => {
          const project = projects.find(
            (p) => p.projectInfo.projectID === value
          );

          setSelectedProject(project.projectInfo);
        }}
        options={projects?.map((project) => ({
          label: `${project.projectInfo["Project Name"] || "Unnamed Project"}`,
          value: project.projectInfo.projectID,
        }))}
        showSearch
        filterOption={(input, option) =>
          (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
        }
      />
    </div>
  );

  return (
    <Modal
      // title="Get Purchased Orders"
      open={isGetPurchasedOrdersVisible}
      centered
      onCancel={onCancel}
      width={currentStep === 1 ? 400 : 1000}
      footer={[
        currentStep === 1 ? (
          <>
            <Button
              key="continue"
              type="primary"
              onClick={handleContinue}
              disabled={!selectedProject}
            >
              Continue
            </Button>
          </>
        ) : (
          <>
            <Button key="back" onClick={onBack}>
              Back
            </Button>
            <Button
              key="send"
              type="primary"
              onClick={handleSendToKoncurent}
              disabled={selectedItems.length === 0}
            >
              Send to Koncurent
            </Button>
          </>
        ),
      ]}
    >
      {currentStep === 1 ? renderProjectList() : renderNextStep()}
    </Modal>
  );
};

export default GetPurchasedOrders;
